import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { PublishDesignDocument } from './publish.generated';

export const usePublishDesign = (options: ApiOptions<typeof PublishDesignDocument> = {}) => {
  const { t } = useTranslation();
  return useMutation(PublishDesignDocument, {
    ...useNotifications(PublishDesignDocument, {
      failure: t('api.common.error_generic'),
      success: t('api.designs.publish_success'),
    }),
    ...options,
  });
};
